export const toArray = (str: any, delimiter: string = ",") => {
  if (!str) return str;
  return str?.toString()?.split(delimiter);
};

export const toBool = (str: any) => {
  if (!str) return str;
  return str?.toString()?.toLowerCase()?.trim() === "true";
};
